import React from "react"
type NodeProps = {
    children: React.ReactNode
}
import { useLocation } from "@reach/router"
export const Bold = ({ children }: NodeProps) => <strong className="rich-text-bold">{children}</strong>

export const Text = ({ children }: NodeProps) => {
    const location = useLocation()
    // children?.map((text, index) => {
    //     text == "/n" ? (
    //         console.log(location)
    //     ) : (
    //         (typeof text === 'string' && text.includes('/n')) ? text?.split('/n').map((phrase, index) => (
    //             console.log(location)
    //         )) : <>{text}</>
    //     )
    // })
    return (
        <p className="rich-text-p">
            {/* {
                children?.map((text, index) => {
                    return text == "/n" ? (
                        <span className="next-line" key={index}>&nbsp;</span>
                    ) : (
                        <span key={index}>
                            {
                                (typeof text === 'string' && text.includes('/n')) ? text?.split('/n').map((phrase, index) => (
                                    <span key={index} style={{ display: 'block' }}>{phrase}</span>
                                )) : <>{text}</>
                            }
                        </span>
                    )
                })
            } */}
            {children}
        </p >
    )
}


export const Heading1 = ({ children }: NodeProps) => (
    <h1 className="heading heading-1">{children}</h1>
)

export const Heading2 = ({ children }: NodeProps) => (
    <h2 className="heading heading-2">{children}</h2>
)

export const Heading3 = ({ children }: NodeProps) => (
    <h3 className="heading heading-3">{children}</h3>
)

export const Heading4 = ({ children }: NodeProps) => (
    <h4 className="heading heading-4">{children}</h4>
)